export default __webpack_public_path__ + "images/c16546fb110e1343ddf54f6bdf3fecb5-bluegrass.jpg";